import React, { useEffect, useRef, useState } from "react";
import { Box, Drawer, IconButton, Typography, Avatar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu"; // hambúrguer
// Se preferir seta: import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { makeStyles } from "@mui/styles";

import { onLayoutReadyApi } from "api";
import Content from "app/components/content/Content";
import Errors from "app/components/errors/Errors";
import NavigationSidebar from "app/components/navigation/Sidebar";
import logoGB from "img/gbonline-logo.png";

const SIDEBAR_WIDTH = 280;
const MD_MIN = "900px"; // md padrão do MUI

const useStyles = makeStyles({
  containerMain: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    flexDirection: "column",
    [`@media (min-width:${MD_MIN})`]: {
      flexDirection: "row",
      paddingLeft: SIDEBAR_WIDTH, // desloca conteúdo no desktop
    },
  },

  // Sidebar fixa no desktop
  sidebar: {
    display: "none",
    [`@media (min-width:${MD_MIN})`]: {
      display: "block",
      width: SIDEBAR_WIDTH,
      flexShrink: 0,
      borderRight: "1px solid #5f5f5fff",
      backgroundColor: "#222",
      position: "fixed",
      top: 0,
      left: 0,
      height: "100vh",
      color: "#f0f0f0",
    },
  },

  sidebarMobile: {
    display: "block",
    width: SIDEBAR_WIDTH,
    flexShrink: 0,
    borderRight: "1px solid #5f5f5fff",
    backgroundColor: "#222",
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    color: "#f0f0f0",
  },

  // Top bar mobile (com o botão)
  mobileTopBar: {
    right: 20,
    top: 10,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    padding: "4px 8px",
    position: "absolute",
    zIndex: 1200,
    background: "#0867afff", // mesma cor do header antigo
    color: "#f0f0f0",
    borderBottom: "1px solid #5f5f5fff",
    [`@media (min-width:${MD_MIN})`]: {
      display: "none", // some no desktop
    },
    height: 56,
  },
  mobileTopBarLogo: {
    position: "absolute",
    top: 10,
    left: 20,
    zIndex: 1200,
    [`@media (min-width:${MD_MIN})`]: {
      display: "none", // some no desktop
    },
  },
  mobileTitle: {
    fontSize: 14,
    fontWeight: 600,
  },
  mobileIconButton: {
    color: "#f0f0f0",
  },

  // Drawer do mobile (usa a mesma NavigationSidebar)
  drawerPaper: {
    width: SIDEBAR_WIDTH,
    backgroundColor: "#222",
    color: "#666666ff",
    borderRight: "1px solid #5f5f5fff",
  },

  pageBody: {
    display: "flex",
    flex: 1,
  },
  pageContent: {
    width: "100%",
  },
  mainContentWrapper: {
    padding: 16,
    [`@media (min-width:${MD_MIN})`]: { padding: 24 },
  },
});

const Layout = ({ children }) => {
  const pageRef = useRef();
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    onLayoutReadyApi(pageRef.current);
  }, []);

  const toggleMobile = () => setMobileOpen((v) => !v);

  return (
    <Box className="page" ref={pageRef}>
      <Errors />
      <Box className={classes.mobileTopBarLogo}>
        <Avatar
          alt="GB Online"
          src={logoGB}
          sx={{ width: "100%" , height: 56, borderRadius: "8px" }}
        />
      </Box>
      {/* Top bar no mobile com botão hambúrguer (ou use uma seta) */}
      <Box className={classes.mobileTopBar}>
        <IconButton
          className={classes.mobileIconButton}
          onClick={toggleMobile}
          aria-label="Abrir menu"
          size="small"
        >
          <MenuIcon
            color="inherit" // cor do ícone
            fontSize="inherit" // herda tamanho do botão
            style={{ fontSize: 22, color: "#fff" }} // tamanho do ícone
          />
          {/* Ou seta: <ChevronRightIcon /> */}
        </IconButton>
        <Typography className={classes.mobileTitle}>Menu</Typography>
      </Box>

      <Box className={classes.containerMain}>
        {/* Sidebar fixa (desktop) */}
        <div className={classes.sidebar}>
          <NavigationSidebar />
        </div>

        <Drawer
          open={mobileOpen}
          onClose={toggleMobile}
          variant="temporary"
          ModalProps={{ keepMounted: true }}
          PaperProps={{ className: classes.drawerPaper }}
          sx={{ display: { xs: "block", md: "none" } }}
        >
          <div className={classes.sidebarMobile}>
            <NavigationSidebar />
          </div>
        </Drawer>

        {/* Conteúdo */}
        <Box className={classes.pageBody}>
          <main className={classes.pageContent}>
            <div className={classes.mainContentWrapper}>{children}</div>
            <footer className="page-footer">
              <Content id="footer" />
            </footer>
          </main>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
